import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { makeBackendApi } from 'services/BackendApi';
import { IAvailableCurrenciesResponse, IAvailableCurrency } from 'services/BackendApi/types/AvailableCurrenciesResponse';
import { sortBy } from 'lodash-es';

const AVAILABLE_CURRENCIES_QUERY_KEY = 'availableCurrencies';

export const useAvailableCurrencies = (enabled = true) => {
  const { data: currencies, ...rest } = useQuery({
    queryKey: [AVAILABLE_CURRENCIES_QUERY_KEY],
    queryFn: async (): Promise<IAvailableCurrency[]> => {
      const api = makeBackendApi();
      const response = await api.getAvailableCurrencies();
      return (response.data as IAvailableCurrenciesResponse).data;
    },
    staleTime: 0,
    enabled,
  });

  const sortedCurrencies = useMemo(() => {
    if (!currencies || currencies.length === 0) return [];
    return sortBy(currencies, c => c.to.name);
  }, [currencies]);

  return { sortedCurrencies, ...rest };
};
